"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.DialogSwitch = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _utilities = require("@fluentui/utilities");

var React = _interopRequireWildcard(require("react"));

/**
 * Ensures that only a single dialog is open at time
 */
var DialogSwitch = /*#__PURE__*/function (_BaseComponent) {
  (0, _inherits2.default)(DialogSwitch, _BaseComponent);

  var _super = (0, _createSuper2.default)(DialogSwitch);

  function DialogSwitch() {
    (0, _classCallCheck2.default)(this, DialogSwitch);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(DialogSwitch, [{
    key: "render",
    value: function render() {
      var _context,
          _this = this;

      var _this$props = this.props,
          type = _this$props.type,
          parameters = _this$props.parameters,
          children = _this$props.children;

      if (type === undefined) {
        return null;
      }

      var selectedDialog;
      (0, _forEach.default)(_context = React.Children).call(_context, children, function (dialog) {
        if ( /*#__PURE__*/React.isValidElement(dialog)) {
          var key = dialog.key;

          if (type === key) {
            var props = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, parameters), {}, {
              dismiss: _this.props.defaultDismiss(parameters || {}),
              isOpen: true
            });
            var dismissAction = dialog.props.dismissAction || '';

            if (dismissAction) {
              props.dismiss = _this.props.customDismiss(dismissAction, parameters || {});
            }

            selectedDialog = /*#__PURE__*/React.cloneElement(dialog, props);
          }
        }
      });
      return selectedDialog || null;
    }
  }]);
  return DialogSwitch;
}(_utilities.BaseComponent);

exports.DialogSwitch = DialogSwitch;